




























import Vue from 'vue'
/* eslint-disable no-console */
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { USER_NS } from '~/store/modules/shared/user/state'
import { mapGetters } from 'vuex'
export default Vue.extend({
  props: {
    isActive: { type: Boolean, required: false, default: false },
    avatar: { type: String, required: false, default: '' },
    alt: { type: String, required: false, default: '' },
    clickable: { type: Boolean, required: false, default: false },
    participantId: { type: Number, required: false, default: null }
  },
  data() {
    return {
      icons: {
        user: faUser
      }
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    })
  }
})
